export const COMPONENT_BASE = 'ContractBillAdjust';
export const COMPONENT_MAIN = `${COMPONENT_BASE}Main`;
export const COMPONENT_LIST = `${COMPONENT_BASE}List`;
export const COMPONENT_DETAIL = `${COMPONENT_BASE}Detail`;

export const TAB_LIST = 'list';
export const OPERATION_LIST_DEFAULT = 'list.default';

export const TAB_DETAIL = 'detail';
export const OPERATION_DETAIL_SHOW = 'detail.show';
export const OPERATION_DETAIL_ADD = 'detail.add';
export const OPERATION_DETAIL_EDIT = 'detail.edit';

export const FN_SET_OPERATION = 'setOperation';
export const FN_SET_TAB = 'setTab';

export const FN_LIST_QUERY = 'query';

export const FN_TO_DETAIL_SHOW = 'toDetailShow';
export const FN_TO_DETAIL_ADD = 'toDetailAdd';
export const FN_TO_DETAIL_EDIT = 'toDetailEdit';

export const ENUM_CONTENT_POWER = 'POWER'; // 用电
export const ENUM_CONTENT_NETWORK = 'NETWORK'; // 宽带

export const MODEL_KEY_ID = 'id';

export const PERMISSION_ADD = null;
export const PERMISSION_EDIT = null;
export const PERMISSION_DELETE = null;
